export default __webpack_public_path__ + "static/media/2030.e0bdff27.png";